<script lang="ts">
  import { get,  writable } from "svelte/store";
  import ContactDropdown from "../../components/Business/ContactDropdown.svelte";
  import CompanyDropdown from "../../components/Business/CompanyDropdown.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import InvoiceDashboard from "../../components/Business/InvoiceDashboard.svelte";
  import Table from "../../components/Table/Table.svelte";
  import type { ICompanyInvoice } from "../../entities";
  import type { ICompanyInvoiceDTO, ICompanyInvoiceEmailDTO } from "../../services/DTO";
  import CustomFields from "../../components/CustomFields/CustomFields.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { companyInvoicePaymentEmailsDtoFields } from "../../utils/TableFields/company-invoice-payment-emails-dto.fields";
  import OwnershipDropdown from "../../components/Form/Fields/Dropdown/OwnershipDropdown.svelte";
  import {setNull} from "../../utils/object-utils";
  import { PermissionService } from "../../utils/misc/permission-utils";

    import { user } from "../../app.store";
  import {
    companyInvoicesEmails,
    pagination_invoicesemails,
    onPageChangeInvoiceEmails,
    filter_invoiceemails,
    searchInvoicesEmails,    
    sendEmails,
    loading_invoicesemails
  } from "./unpaidinvoices.store";
    import Button from "../../components/Button.svelte";
  import Icon from "../../components/Icon.svelte";    
    import type { ICompanyInvoicePaymentEmailDTO } from "../../services/DTO/entity/company-invoice-payment-email-dto";
    import ConfirmModal from "../../components/Modal/ConfirmModal.svelte";

  
  let cansend : boolean = PermissionService.isAllowedTo($user, 'companyinvoices.cansend');
  const sendModalOpen = writable<boolean>(false);
  const selected = writable<ICompanyInvoicePaymentEmailDTO>();
 
    function onResendemail(dto: ICompanyInvoicePaymentEmailDTO){
     selected.set(dto);
    sendModalOpen.set(true); 
    }
    
  async function onSendEmail(){
    let s = get(selected);
    await sendEmails(true, null, s.email.oid);
    sendModalOpen.set(false); 
    searchInvoicesEmails();
  }

  function onCancelEmail(){
    sendModalOpen.set(false); 
  }

    function resetSearchInvoicesEmails(){
      setNull($filter_invoiceemails.criteria);
      searchInvoicesEmails();
    }
</script>

  
<ConfirmModal open={$sendModalOpen}
title="Conferma re-invio"
message="Inviare nuovamente la mail/pec?"
on:confirm={(e) => onSendEmail()}
on:decline={(e) => onCancelEmail()}
/>

    <SearchHeader
      entitySingular="sollecito inviato"
      entityPlural="solleciti inviati"
      numRecords={$pagination_invoicesemails != null ? $pagination_invoicesemails.totalRecords : 0}
      bind:searchValue={$filter_invoiceemails.criteria.query}
      on:search={() => searchInvoicesEmails()}
      on:reset={() => resetSearchInvoicesEmails()}      
      searchFieldVisible={false}
      clearButtonVisible={false}
    >

  <div slot="search" class="level">
    <div class="level-item" >
      <div>
        <FormField>
          <DateInput
            name=""
            placeholder="Data Inizio"
            required={false}
            bind:value={$filter_invoiceemails.criteria.dataFrom}
              on:dateChanged={searchInvoicesEmails}
          />
        </FormField>
        <FormField>
          <CompanyDropdown
            name=""
            placeholder="Filtra per cliente..."
            required={false}
            clearVisible={true}
            bind:value={$filter_invoiceemails.criteria.companyid}
            on:select={searchInvoicesEmails}
          />
        </FormField>
      </div>
    </div>


    <div class="level-item" >
      <div>
        <FormField>
          <DateInput
            name=""
            placeholder="Data Fine"
            required={false}
            bind:value={$filter_invoiceemails.criteria.dataTo}
              on:dateChanged={searchInvoicesEmails}
          />
        </FormField>
        <FormField>
          <OwnershipDropdown
            name=""
            placeholder="Filtra per az. proprietaria..."
            required={false}
            clearVisible={true}
            bind:value={$filter_invoiceemails.criteria.ownershipid}
            on:select={searchInvoicesEmails}
          />
        </FormField>
      </div>
    </div>
    <div class="level-item" >
      <div>
        <FormField usageHelp="Visualizza solo invii falliti">
          <Switch
            name=""
            condensed={true}
            altText="Solo invii falliti"
            bind:value={$filter_invoiceemails.criteria.falliti}
            on:toggle={searchInvoicesEmails}
          />
        </FormField>
      </div>
    </div>

    <div class="level-item">
      <div>
        <FormField  >
          <Input
            placeholder ="Diag. errore"
            required={false} 
            bind:value={$filter_invoiceemails.criteria.diagnostico}
            on:enter={searchInvoicesEmails}
          />
        </FormField>

      </div>
    </div>

    <div class="level-item">
      <div>


      </div>
    </div>

    <div class="level-item">
      <p class="control">
        <Button on:click={searchInvoicesEmails}>
          <Icon name="search" />

          <span> Cerca </span>
        </Button>
      </p>
    </div>

    <div class="level-item">
      <p class="control">
        <Button on:click={resetSearchInvoicesEmails}>Azzera</Button>
      </p>
    </div>
  </div>

  </SearchHeader>

  <Table
    loading={$loading_invoicesemails}
    fields={companyInvoicePaymentEmailsDtoFields}
    records={$companyInvoicesEmails}
    pagination={$pagination_invoicesemails}
    createEnabled={false}
    editEnabled={false}
    customEnabled={cansend}
    customIcon="send"
    deleteEnabled={false}
    downloadEnabled={false}
    on:custom={(e) => onResendemail(e.detail)}
    on:pageChange={(e) => onPageChangeInvoiceEmails(e.detail)}
  />
 